var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "k-page",
    { staticClass: "login" },
    [
      _c(
        "div",
        { attrs: { id: "bg-image-wrapper" } },
        [
          _c("transition", { attrs: { name: "fade" } }, [
            _c("img", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.show,
                  expression: "show",
                },
              ],
              attrs: { id: "bg-image", src: _vm.img },
              on: { load: _vm.showImg },
            }),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "featured-outer small" }),
      _c("k-main", { attrs: { title: _vm.title } }, [
        _vm.then
          ? _c("div", { staticClass: "message" }, [
              _vm._v("Please log in or sign up to access that page/content."),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }